// extracted by mini-css-extract-plugin
export var measureBox = "_am-0";